import { styled } from "@lib/components";
import { lighten } from "polished";

export const ErrorBoxLight = styled.div`
  color: ${({ theme }) => lighten(0, theme.colors.error)};
  background: ${({ theme }) => lighten(0.48, theme.colors.error)};
`;
